<script lang="ts">
	import ShellyScriptHightlight from '../Editor/ShellyScriptHightlight';
	export let code: string;

	const updateLines = (container: HTMLElement) => {
		let numberList = '';
		code.split('\n').forEach((_e, i) => {
			numberList += `<span>${i + 1}</span>`;
		});
		container.innerHTML = numberList;
	};
</script>

<div class="js-editor shelly-code-editor">
	<div class="line-numbers" use:updateLines />
	<div class="editor-content">
		{@html ShellyScriptHightlight.highlight(code)}
	</div>
</div>

<style>
	.js-editor {
		width: 100%;
		height: auto;
		min-height: 32px;
		padding: 4px;
		position: relative;
		font-size: 13px;
		font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
		line-height: 20px;
		white-space: pre;
		border-radius: var(--radius-small);
		background: #fff;
		box-sizing: border-box;
		color: #003366;
		display: flex;
		overflow: hidden;
	}

	.editor-content {
		overflow: auto;
		padding-left: 45px;
		padding-top: 6px;
	}
</style>
